import React, { RefObject, useRef, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { DefaultButton, MessageBar, Panel, PanelType, IMessageBarProps, PrimaryButton, MessageBarType } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import ContactForm, { ContactFormHandle } from './ContactForm';
import { IDestinatarioProtocollo, IField } from '../../shared/interfaces';

export interface ContactPanelProps {
    extraCssClass?: string
    contactPanelIsOpen: boolean
    onContactDismiss: () => void
    onAddClick: (destinatarioProtocollo: Partial<IDestinatarioProtocollo>) => void

}

type Props = ContactPanelProps

export interface ContactPanelState {
    panelIsOpen: boolean
    messageBarIsVisible: boolean
    messageBarProps: IMessageBarProps
    destinatarioProtocollo: Partial<IDestinatarioProtocollo>

}

class ContactPanel extends React.Component<Props, ContactPanelState> {
    private contactFormRef: RefObject<ContactFormHandle>;
    constructor(props) {
        super(props);
        this.state = {
            panelIsOpen: this.props.contactPanelIsOpen,
            messageBarIsVisible: false,
            messageBarProps: {
                dismissButtonAriaLabel: "Close",
                messageBarType: MessageBarType.error,
                children: ''
            },
            destinatarioProtocollo: {}

        }
        // Crea il ref e assegnalo al tipo corretto
        this.contactFormRef = React.createRef<ContactFormHandle>();
    }

    componentDidUpdate(prevProps: Props, prevState: any) {
        if (prevProps.contactPanelIsOpen !== this.props.contactPanelIsOpen) {
            this.setState({ panelIsOpen: this.props.contactPanelIsOpen });
        }
    }

    contactPanelDismiss = () => {
        this.props.onContactDismiss();
    }

    onAddClick = () => {


        if (this.contactFormRef.current && this.contactFormRef.current.checkFormValidity()) {
            this.props.onAddClick(this.state.destinatarioProtocollo!);
        }
        else {
            let errorMessageProps: IMessageBarProps = {
                dismissButtonAriaLabel: "Close",
                messageBarType: MessageBarType.error,
                children: `Compilare correttamente tutti i campi obbligatori`,

            };
            this.onError(errorMessageProps);

        }
    }

    onRenderFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Aggiungi"
                    onClick={this.onAddClick}

                />

                <DefaultButton
                    onClick={this.contactPanelDismiss}
                    text="Chiudi"
                />
            </React.Fragment>
        );
    }
    onContactFormChangedHandler = (destinatarioProtocollo: Partial<IDestinatarioProtocollo>) => {
        this.setState({ destinatarioProtocollo: { ...destinatarioProtocollo } });
    }
    onError = (errorMessageProps: IMessageBarProps) => {
        this.setState({ messageBarIsVisible: true, messageBarProps: { ...errorMessageProps } });
    }

    render() {
        let { panelIsOpen, messageBarIsVisible, messageBarProps } = this.state;
        return (
            <Panel
                key='contactPanel'

                isLightDismiss
                isOpen={panelIsOpen}
                type={PanelType.custom}
                customWidth={'600px'}
                headerText="Aggiungi contatto"
                focusTrapZoneProps={{
                    isClickableOutsideFocusTrap: true,
                    forceFocusInsideTrap: true,
                }}
                onDismiss={this.contactPanelDismiss}
                onRenderFooterContent={this.onRenderFooterContent}
                // Stretch panel content to fill the available height so the footer is positioned
                // at the bottom of the page
                isFooterAtBottom={false}

            >
                {
                    messageBarIsVisible &&
                    <MessageBar {...messageBarProps}
                        onDismiss={() => this.setState({ messageBarIsVisible: false })}
                        dismissButtonAriaLabel="Close" />
                }

                <ContactForm ref={this.contactFormRef} showMessageError={this.onError} dismissMessageError={() => this.setState({ messageBarIsVisible: false })} onContactFormChangedHandler={this.onContactFormChangedHandler} />



            </Panel>

        );
    }
}

export default ContactPanel;
